import { useTranslation } from 'react-i18next'

export function useLanguage() {
  const { i18n, t } = useTranslation()

  function toggle() {
    i18n.changeLanguage(i18n.language === 'en' ? 'ta' : 'en')
  }

  return {
    t,
    language: i18n.language,
    isTamil: i18n.language === 'ta',
    toggle,
  }
}
